import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './dialog';
import { useKeyboardShortcuts } from './KeyboardShortcuts.hooks';

const SHORTCUT_HELP = [
  { keys: 'g d', desc: 'Go to Dashboard' },
  { keys: 'g i', desc: 'Go to Invoices' },
  { keys: 'g k', desc: 'Go to Digital Khata' },
  { keys: 'g p', desc: 'Go to Point of Sale' },
  { keys: 'g v', desc: 'Go to Inventory' },
  { keys: 'g s', desc: 'Go to Settings' },
  { keys: 'n i', desc: 'New invoice' },
  { keys: 'n p', desc: 'New product' },
  { keys: '?', desc: 'Show this help' },
];

export const DashboardShortcuts = () => {
  const navigate = useNavigate();
  const [helpOpen, setHelpOpen] = useState(false);

  useKeyboardShortcuts({
    'g+d': () => navigate('/dashboard'),
    'g+i': () => navigate('/invoices'),
    'g+k': () => navigate('/khata'),
    'g+p': () => navigate('/pos'),
    'g+v': () => navigate('/inventory'),
    'g+s': () => navigate('/settings'),
    'n+i': () => navigate('/invoices?action=new'),
    'n+p': () => navigate('/inventory?action=add-product'),
    // "?" (shift+/) opens the discoverable shortcuts dialog.
    'shift+?': () => setHelpOpen(true),
    '?': () => setHelpOpen(true),
  });

  return (
    <Dialog open={helpOpen} onOpenChange={setHelpOpen}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
          <DialogDescription>Press these keys when not typing in a field.</DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 text-sm">
          {SHORTCUT_HELP.map((s) => (
            <li key={s.keys} className="flex items-center justify-between gap-4">
              <span className="text-muted-foreground">{s.desc}</span>
              <kbd className="rounded border bg-muted px-1.5 py-0.5 font-mono text-xs">{s.keys}</kbd>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
